// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"197":"265d2f83","791":"d3167885","870":"fffe6935","880":"a4773612","969":"494ca895"}[chunkId] + ".chunk.js";
};